<template>
  <textarea ref="textarea" :rows="rows" v-bind="$attrs" v-model="input" :maxlength="max" />
</template>

<script setup>
import { useTextareaAutosize } from '@vueuse/core'
import { nextTick, watch } from 'vue'

const props = defineProps({
  rows: { type: [String, Number], default: 1 },
  prefix: { type: String, default: '' },
  max: { type: Number, default: Infinity },
})
const model = defineModel()
const { textarea, input } = useTextareaAutosize({
  input: model,
  styleProp: props.rows > 1 ? 'minHeight' : 'height',
})

watch(
  input,
  async (newVal, oldVal) => {
    await nextTick()
    oldVal ??= ''
    newVal ??= ''
    if (props.prefix && !oldVal.startsWith(props.prefix)) {
      oldVal = props.prefix + oldVal
    }
    if (props.prefix && !newVal.startsWith(props.prefix)) {
      input.value = oldVal
    }
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped>
textarea {
  resize: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

textarea::placeholder {
  color: $grey-100;
}

textarea::-webkit-scrollbar {
  display: none;
}
</style>
